import clsx from 'clsx'
import { messageDanger, messageInfo, messageSuccess, messageWarning } from './style.css'

type MessageType = 'success' | 'danger' | 'warning' | 'info'

type MessageProps = {
  type?: MessageType
} & React.HTMLAttributes<HTMLDivElement>

const MSG_TYPE_TO_CLS = {
  success: messageSuccess,
  danger: messageDanger,
  warning: messageWarning,
  info: messageInfo,
}

export default function Message({ type, className, children, ...rest }: MessageProps) {
  return (
    <div className={clsx(MSG_TYPE_TO_CLS[type ?? 'info'], className)} {...rest}>
      {children}
    </div>
  )
}
